import { Directive, ElementRef, model, inject, OnChanges } from "@angular/core";
import { BreakpointService } from "@app/core/services/breakpoint.service";
import { ComponentChanges } from "@app/shared/models/on-changes.model";

/**
 * example of use:
 *
 * autofocus field on view:
 *
 * <input appAutoFocus></>
 *
 * autofocus based on condition:
 *
 * <input [appAutoFocus]="xxx"></>
 */
@Directive({
  selector: "[appAutoFocus]"
})
export class AutoFocusDirective implements OnChanges {
  private elementRef = inject(ElementRef);
  private bps = inject(BreakpointService);
  appAutoFocus = model<boolean | string>();

  ngOnChanges(changes: ComponentChanges<this>) {
    if (changes.appAutoFocus) {
      // When empty string is passed in, focus is true. This is the default behavior
      if (this.appAutoFocus() === "") {
        this.appAutoFocus.set(true);
      } else {
        this.appAutoFocus.set(!!this.appAutoFocus());
      }
      this._focusInput();
    }
  }

  private _focusInput() {
    if (this.appAutoFocus() && !this.bps.isMobile()) {
      setTimeout((): void => {
        this.elementRef?.nativeElement?.focus();
      }, 50);
    }
  }
}
